import axios from "axios";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import server from "../../api/server";

export async function getData({ setData, setLoading = () => {}, url }) {
	try {
		setLoading(true);
		let { data } = await axios.get(
			`${process.env.REACT_APP_MAIN_URL}/api/${url}`,
			{
				headers: {
					Authorization: `Bearer ${Cookies.get("token")}`,
					Accept: "application/json",
					"Content-Type": "multipart/form-data",
				},
			}
		);
		setData(data);
		setLoading(false);
	} catch (error) {
		setLoading(false);
		toast.error("حدث خطا ما");
	}
}

export async function postData({
	url,
	body = {},
	setData = () => {},
	setLoading,
}) {
	try {
		setLoading(true);
		let { data } = await server().post(url, body);
		setData(data);
		setLoading(false);
	} catch (error) {
		setLoading(false);
		toast.error("حدث خطا ما");
	}
}

export async function putData({
	url,
	body = {},
	setData = () => {},
	setLoading,
}) {
	try {
		setLoading(true);
		let { data } = await server().put(url, body);
		setData(data);
		setLoading(false);
	} catch (error) {
		setLoading(false);
		toast.error("حدث خطا ما");
	}
}

export async function deleteData({ url, setData = () => {}, setLoading }) {
	try {
		setLoading(true);
		await server().delete(url);
		setData({});
		setLoading(false);
	} catch (error) {
		setLoading(false);
		toast.error("حدث خطا ما");
	}
}
